module.exports = __webpack_public_path__ + "img/gamacidadao.9aa2c42e.jpg";